/* Graph of Life brand v1.0.0 · tokens.json */
// Buyer-facing application areas, organized by the decision being investigated.

export const applications = [
  {
    id: 'screening',
    label: '01 / Nature risk',
    title: 'Where does exposure begin?',
    copy:
      'Trace the ecological relationships behind an asset or operation and identify which pathways warrant closer diligence.',
    decisionProblem:
      'Which ecological dependencies could affect this asset, operation or bounded portfolio slice?',
    artifact:
      'A dependency graph, critical-pathway analysis and a register of evidence gaps.',
    boundary:
      'Supports exploratory screening and diligence preparation. Validated credit, underwriting, pricing, loss and prudential measures require separate institutional data, domain validation and independent review.',
    proofs: ['bluegraph', 'ai-ecologist', 'fluvion', 'upper-colorado'],
  },
  {
    id: 'evidence-architecture',
    label: '02 / Natural capital',
    title: 'What would support the claim?',
    copy:
      'Connect field observations, remote sensing and molecular evidence to the requirements of a monitoring programme or ecological claim.',
    decisionProblem:
      'What evidence would need to exist before an eligibility, performance or claim conclusion could be considered?',
    artifact:
      'An evidence architecture linking each claim to its sources and missing measurements.',
    boundary:
      'Organizes evidence for review. Returns, eligibility, ecological performance, calibrated risk, pricing and allocation each require their own validation.',
    proofs: ['bluegraph', 'methanet', 'bioprior'],
  },
  {
    id: 'accountable-ai',
    label: '03 / Accountable AI',
    title: 'Can the reasoning be examined?',
    copy:
      'Make the evidence and assumptions behind a conclusion queryable. AI supports the investigation; domain owners guide interpretation and action.',
    decisionProblem:
      'Can the evidence, assumptions and decision rules behind a conclusion be inspected and challenged?',
    artifact:
      'A governed knowledge graph, an uncertainty ledger and inspectable decision traces.',
    boundary:
      'AI organizes and tests the evidence. Institutional data, domain validation and accountable human review remain central to interpretation.',
    proofs: ['bluegraph', 'ai-ecologist'],
    internalLink: { label: 'Governed knowledge-graph architecture', to: '/knowledge' },
  },
];
